import React, { VoidFunctionComponent, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate, useParams } from 'react-router-dom';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { RoutePaths } from '../classes/RoutePaths/RoutePaths';
import { useEntityManager } from '../hooks/entity/useEntityManager';
import { useCurrentUser } from '../hooks/useCurrentUser';
import {
  AuthenticatedPermission,
  NavigationConfigurationWithKey
} from './navigationConfigurations';

export type AppRouteElementWrapperProps = {
  config: NavigationConfigurationWithKey;
};

export const AppRouteElementWrapper: VoidFunctionComponent<AppRouteElementWrapperProps> =
  React.memo((props) => {
    const { config } = prepareProps({ props, ignoreChildren: true });

    const { t } = useTranslation();
    useEffect(() => {
      document.title = String(t(config.titleTk));
    }, [t, config.titleTk]);

    const params = useParams();
    const { entityManager } = useEntityManager();

    const { getRequiredCurrentUserPermissions } = useCurrentUser();
    let hasPermission = true;
    if (
      config.permissions.authenticated ===
        AuthenticatedPermission.OnlyAuthenticated &&
      config.permissions.checkUserPermissions
    ) {
      hasPermission = config.permissions.checkUserPermissions({
        userPermissions: getRequiredCurrentUserPermissions(),
        params,
        entityManager
      });
    }

    if (!hasPermission) {
      return <Navigate to={RoutePaths.home()}></Navigate>;
    }

    return config.routeProps.element;
  });
